<template>
  <div>
    <!-- BT MODAL -->
    <div class="container-fluid">
      <div class="row">
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row" v-if="!savingAccount">
              <div class="col-md-12">
                <div class="row my-3">
                  <div class="col-md-4 text-md-right">
                    Account Type <span class="text-danger">*</span>
                  </div>
                  <div class="col-md-7">
                    <el-dropdown trigger="click" class="w-100 mt-2">
                      <span class="el-dropdown-link w-100">
                        <div
                          class="d-flex justify-content-between border-contribution w-100"
                          size="large"
                        >
                          <div>
                            {{
                              !selectedAccountType || !selectedAccountType.name
                                ? "Select account type"
                                : selectedAccountType.name
                            }}
                          </div>
                          <div>
                            <el-icon class="el-icon--right">
                              <arrow-down />
                            </el-icon>
                          </div>
                        </div>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item
                            v-for="(accounts, index) in transactionalAccounts"
                            :key="index"
                          >
                            <div class="col-md-12 px-2">
                              <div
                                v-if="accounts.length > 0"
                                class="py-2 font-weight-700 border-bottom"
                              >
                                {{ accountTypes[index] }}
                              </div>
                              <div
                                v-for="(account, indx) in accounts"
                                :key="indx"
                                @click="selectAccountType(account, index)"
                                class="c-pointer py-2"
                              >
                                {{ account.name }}
                              </div>
                            </div>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </div>
                </div>

                <div class="row my-3">
                  <div class="col-md-4 text-md-right">
                    Account Name <span class="text-danger">*</span>
                  </div>
                  <div class="col-md-7">
                    <el-input
                      type="text"
                      v-model="newAccount.name"
                      class="w-100"
                    />
                  </div>
                </div>
                <div class="row my-3">
                  <div class="col-md-4 text-md-right">Account Code</div>
                  <div class="col-md-7">
                    <el-input
                      type="text"
                      v-model="newAccount.code"
                      class="w-100"
                    />
                  </div>
                </div>

                <div
                  class="row my-3"
                  v-if="
                    currency ||
                    setAcountHeadType == 'assets' ||
                    setAcountHeadType == 'liability'
                  "
                >
                  <div class="col-md-4 text-md-right">Account Currency</div>
                  <div class="col-md-7" id="currencySelect">
                    <el-select
                      v-model="selectedCurrencyID"
                      placeholder="Select"
                      class="w-100"
                      @change="setSelectedCurrency"
                      filterable
                    >
                      <el-option
                        v-for="item in accountCurrencies"
                        :label="item.displayName"
                        :value="item.id"
                        :key="item.id"
                      />
                    </el-select>
                    <!-- <el-select-v2
                      v-model="selectedCurrencyID"
                      class="w-100 font-weight-normal"
                      :options="
                        accountCurrencies.map((i) => ({
                          label: i.displayName,
                          value: i.id,
                        }))
                      "
                      placeholder="Select account currency"
                      @change="setSelectedCurrency"
                      size="large"
                    /> -->
                  </div>
                </div>

                <div
                  class="row my-3"
                  v-if="
                    showFundsField ||
                    setAcountHeadType == 'expense' ||
                    setAcountHeadType == 'income' ||
                    setAcountHeadType == 'equity'
                  "
                >
                  <div class="col-md-4 text-md-right">Fund</div>
                  <div class="col-md-7">
                    <el-select-v2
                      v-model="selectedFundID"
                      class="w-100 font-weight-normal"
                      :options="
                        funds.map((i) => ({
                          label: i.name,
                          value: i.id,
                        }))
                      "
                      @change="setSelectedFund"
                      size="large"
                    />
                  </div>
                </div>
                <div class="row my-3">
                  <div class="col-md-4 text-md-right"></div>
                  <div class="col-md-7">
                    <div class="cursor-pointer mt-3" @click="toggleAdvanced">
                      <div class="s-18 font-weight-600" style="cursor: pointer">
                        <el-icon
                          style="color: #1b809c"
                          :size="18"
                          v-if="isAdvancedOpen"
                          ><CaretTop
                        /></el-icon>
                        <el-icon style="color: #1b809c" :size="16" v-else
                          ><CaretBottom
                        /></el-icon>
                        <span class="ml-1"> Advanced Options</span>
                      </div>
                    </div>

                    <div class="form-row mt-3" v-show="isAdvancedOpen">
                      <div class="col-md-12 d-flex align-items-center">
                        <div class="form-check mr-3">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="isSubAccount"
                            v-model="newAccount.isSubAccount"
                          />
                          <label
                            class="form-check-label text-black"
                            for="isSubAccount"
                          >
                            Is a Sub-Account?
                          </label>
                        </div>
                        <div class="form-check">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            id="isContraAccount"
                            v-model="newAccount.isContraAccount"
                          />
                          <label
                            class="form-check-label text-black"
                            for="isContraAccount"
                          >
                            Is a Contra Account?
                          </label>
                        </div>
                      </div>

                      <div class="col-md-12 mb-3">
                        <span class="text-dak s-12">
                          This account will subtract from its parent e.g Accum.
                          Depreciation
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row my-3"
                  v-if="
                    newAccount.isSubAccount ||
                    (newAccount.isContraAccount && isAdvancedOpen)
                  "
                >
                  <div class="col-md-4 text-md-right">Parent Account</div>
                  <div class="col-md-7">
                    <el-select-v2
                      v-model="selectedParentAccountID"
                      @change="setSelectedParentAccount"
                      :options="
                        parentAccounts.map((i) => ({
                          label: i.name,
                          value: i.id,
                        }))
                      "
                      placeholder="Select Account"
                      size="large"
                      class="w-100 mb-3"
                    />
                  </div>
                </div>
                <div class="row my-3" v-if="isAdvancedOpen">
                  <div class="col-md-4 text-md-right">Description</div>
                  <div class="col-md-7">
                    <el-input
                      id="description"
                      v-model="newAccount.description"
                      :rows="3"
                      type="textarea"
                      class="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row my-4" v-if="savingAccount">
              <div class="col-md-12 text-center">
                <el-icon :size="20" class="is-loading">
                  <Loading />
                </el-icon>
              </div>
            </div>

            <div class="row my-3">
              <div class="col-md-4 text-md-right"></div>
              <div class="col-md-7">
                <p class="text-danger" v-if="invalidAccountDetails">
                  Please select account type and provide account name
                </p>
              </div>
            </div>
            <div class="row" style="border-top: 1px solid #dee2e6">
              <div class="col-md-12 d-flex justify-content-end mt-3">
                <el-button round class="mr-3" data-dismiss="modal">
                  Cancel
                </el-button>
                <el-button
                  @click="onSave"
                  round
                  :loading="savingAccount"
                  :color="primarycolor"
                  :disabled="
                    (setAcountHeadType == 'expense' ||
                      setAcountHeadType == 'income' ||
                      setAcountHeadType == 'equity') &&
                    selectedFund &&
                    !selectedFund.name
                  "
                  class="border-0 text-white"
                >
                  Save
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END BT -->
  </div>
</template>

<script>
import { computed, ref, inject, watch } from "vue";
import transactionals from "../utilities/transactionals";
import chart_of_accounts from "../../../../services/financials/chart_of_accounts";
import membershipService from "../../../../services/membership/membershipservice";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";

export default {
  props: [
    "transactionalAccounts",
    "accountTypes",
    "currencies",
    "showFundsField",
    "financialAccountType",
    "accountGroupId",
    "index",
    "account",
    "currency",
    "chartOfAccounts",
  ],
  components: {},
  setup(props, { emit }) {
    const store = useStore();
    const loading = ref(false);
    const primarycolor = inject("primarycolor");

    const selectedAccountType = ref({});
    const selectedCurrency = ref({});
    const selectedFund = ref({});
    const newAccount = ref({});
    const accountCurrencies = ref([]);
    const selectedCurrencyID = ref(null);
    const selectedFundID = ref(null);
    const chartOfAccounts = ref([]);
    const selectedParentAccountID = ref(null);
    const setAcountHeadType = ref("");
    const userCurrency = ref(
      store.getters.currentUser ? store.getters.currentUser.currency : ""
    );

    const isAdvancedOpen = ref(false);
    const isSubAccount = ref(false);
    const isContraAccount = ref(false);
    const selectedParentAccount = ref("");
    const filteredAccounts = ref([]);

    const parentAccounts = ref([]);

    const localTransactionalAccounts = ref([]);
    const localAccountTypes = ref([]);
    const getCharts = async () => {
      try {
        const response = await chart_of_accounts.getChartOfAccounts();

        chartOfAccounts.value = response.accountwithHeads;
      } catch (error) {
        console.log(error);
      }
    };
    getCharts();

    const processChartOfAccounts = () => {
      localTransactionalAccounts.value = [];
      localAccountTypes.value = [];

      if (!chartOfAccounts.value || !Array.isArray(chartOfAccounts.value)) {
        return;
      }

      chartOfAccounts.value.forEach((accountGroup) => {
        localAccountTypes.value.push(accountGroup.key);

        const accounts = accountGroup.accountHeadsDTO.flatMap(
          (head) => head.accounts || []
        );

        localTransactionalAccounts.value.push(accounts);
      });
    };

    // **Always run when chartOfAccounts changes**
    watch(
      () => chartOfAccounts.value,
      () => processChartOfAccounts(),
      { immediate: true }
    );

    const selectAccountType = (account, index) => {
      selectedAccountType.value = account;
      // setAcountHeadType.value = localAccountTypes.value[index] || "";
      setAcountHeadType.value =
        props.accountTypes && props.accountTypes[index]
          ? props.accountTypes[index]
          : "";

      // **Filter directly from chartOfAccounts**
      const selectedGroupKey = localAccountTypes.value[index];
      const selectedGroup = chartOfAccounts.value.find(
        (group) => group.key === selectedGroupKey
      );

      if (selectedGroup) {
        // Get all accounts under the selected key
        parentAccounts.value = selectedGroup.accountHeadsDTO.flatMap(
          (head) => head.accounts || []
        );
      } else {
        parentAccounts.value = [];
      }
    };

    const setSelectedParentAccount = () => {
      // console.log(selectedParentAccount.value, 'seledcrpa');

      selectedParentAccount.value = parentAccounts.value.find(
        (i) => i.id == selectedParentAccountID.value
      );
    };

    const toggleAdvanced = () => {
      isAdvancedOpen.value = !isAdvancedOpen.value;
    };

    // const selectAccountType = (account, index) => {
    //   selectedAccountType.value = account;
    //   setAcountHeadType.value =
    //     props.accountTypes && props.accountTypes[index]
    //       ? props.accountTypes[index]
    //       : "";
    //   if (props.transactionalAccounts[index]) {
    //     filteredAccounts.value = props.transactionalAccounts[index];
    //     parentAccounts.value = filteredAccounts.value;
    //   } else {
    //     filteredAccounts.value = [];
    //   }
    // };

    const setSelectedCurrency = () => {
      selectedCurrency.value = accountCurrencies.value.find(
        (i) => i.id == selectedCurrencyID.value
      );
    };

    const setSelectedFund = () => {
      selectedFund.value = funds.value.find(
        (i) => i.id == selectedFundID.value
      );
    };

    const filteredCurrencies = computed(() => {
      if (!props.currencies) return [];
      return props.currencies.map((i) => {
        return { name: `${i.name} - ${i.country}`, id: i.id };
      });
    });

    const funds = ref([]);
    const getFunds = async () => {
      try {
        const response = await transactionals.getFunds();
        funds.value = response;
      } catch (error) {
        console.log(error);
      }
    };
    getFunds();

    const edit = async (body) => {
      try {
        const response = await chart_of_accounts.editAccount(body);
        savingAccount.value = false;
        loading.value = false;
        ElMessage({
          type: "success",
          message: `${response.response}`,
          duration: 3000,
        });
        newAccount.value = {};
        emit("save-account", {
          success: true,
          type: props.financialAccountType,
        });
      } catch (error) {
        savingAccount.value = false;
        loading.value = false;
        ElMessage({
          type: "error",
          message: "Account Update Failed",
          duration: 3000,
        });
        newAccount.value = {};
        emit("save-account", {
          success: true,
          type: props.financialAccountType,
        });
        transactionals.getTransactionalAccounts(true);
        console.log(error);
      }
    };

    const savingAccount = ref(false);
    const saveAccount = async (body) => {
      console.log(`Saving Account:`, body);

      try {
        savingAccount.value = true;
        loading.value = true;
        let response = {};
        if (props.account && props.account.name) {
          const x = {
            name: body.name,
            code: props.account.code,
            accountType: props.account.accountType,
            description: body.description,
            id: props.account.id,
            isSubAccount: body.isSubAccount,
            isContraAccount: body.isContraAccount,
            financialAccountGroupID: selectedAccountType.value.id,
            currencyID: body.currencyID,
            parentID: selectedParentAccount.value
              ? selectedParentAccount.value.id
              : "",
            financialFundID: body.financialFundID,
          };
          response = edit(x);
        } else {
          response = await chart_of_accounts.saveAccount(body);
          savingAccount.value = false;
          loading.value = false;
          if (!response.status) {
            emit("save-account", {
              success: false,
              type: props.financialAccountType,
            });
            ElMessage({
              type: "error",
              message: "Account Creation Failed",
              duration: 3000,
            });
          } else {
            ElMessage({
              type: "success",
              message: `The account ${newAccount.value.name} was created successfully`,
              duration: 3000,
            });
            newAccount.value = {};
            selectedFundID.value = null; // ✅ Reset el-select-v2 dropdown
            selectedFund.value = {}; // ✅ Reset internal fund object
            savingAccount.value = false;
            loading.value = false;
            emit("save-account", {
              success: true,
              type: props.financialAccountType,
            });
            transactionals.getTransactionalAccounts(true);
            selectedFund.value = {};
          }
        }
      } catch (error) {
        savingAccount.value = false;
        console.log(error);
      }
    };

    const invalidAccountDetails = ref(false);
    const onSave = () => {
      invalidAccountDetails.value = false;
      if (
        !selectedAccountType.value ||
        !selectedAccountType.value.name ||
        !newAccount.value.name
      ) {
        invalidAccountDetails.value = true;
        return false;
      }

      newAccount.value.financialAccountGroupID = selectedAccountType.value.id;
      newAccount.value.parentID = selectedParentAccount.value
        ? selectedParentAccount.value.id
        : "";
      // newAccount.value.isSubAccount = isSubAccount.value;
      // newAccount.value.isContraAccount = isContraAccount.value;
      if (selectedCurrency.value && selectedCurrency.value.id) {
        newAccount.value.currencyID = selectedCurrency.value.id;
      }

      // if (selectedFund.value && selectedFund.value.id) {
      newAccount.value.financialFundID =
        selectedFund.value && selectedFund.value.id
          ? selectedFund.value.id
          : "";
      // }
      saveAccount(newAccount.value);
    };

    const initializeCurrency = () => {
      if (!userCurrency.value) {
        membershipService
          .getSignedInUser()
          .then((res) => {
            selectedCurrency.value = accountCurrencies.value.find(
              (i) => i.name === res.currency
            );
          })
          .catch((err) => console.log(err));
      } else {
        selectedCurrency.value = accountCurrencies.value.find((i) => {
          return i.name.includes(userCurrency.value);
        });
      }
    };

    const updateSelectedCurrency = () => {
      selectedCurrency.value = accountCurrencies.value.find(
        (i) => i.id === props.account.id
      );
    };

    const getCurrencies = async () => {
      try {
        const response = await transactionals.getCurrencies();
        accountCurrencies.value = response;
        if (!props.account || !props.account.name) {
          initializeCurrency();
        } else {
          updateSelectedCurrency();
        }
      } catch (error) {
        console.log(error);
      }
    };
    getCurrencies();

    watch(
      () => [props.accountGroupId, props.transactionalAccounts, props.index],
      ([groupId, transactionalAccounts, index]) => {
        if (groupId && transactionalAccounts && transactionalAccounts[index]) {
          selectedAccountType.value =
            transactionalAccounts[index].find((i) => i.name === groupId) || {};

          console.log("selectedAccountTyp", selectedAccountType.value);
        }
        if (props.account) {
          newAccount.value.name = props.account ? props.account.name : "";
          newAccount.value.code = props.account ? props.account.code : "";
          newAccount.value.isSubAccount = props.account
            ? props.account.isSubAccount
            : false;
          newAccount.value.isContraAccount = props.account
            ? props.account.isContraAccount
            : false;
          newAccount.value.description = props.account
            ? props.account.description
            : "";
          selectedFund.value = funds.value.find(
            (i) => i.id === props.account.financialFundID
          );
          selectedCurrency.value = accountCurrencies.value.find(
            (i) => i.id === props.account.currencyID
          );
          selectedFundID.value = props.account.financialFundID || null;
          selectedCurrencyID.value = props.account.currencyID || null;

          setAcountHeadType.value =
            props.accountTypes && props.accountTypes[props.index]
              ? props.accountTypes[props.index]
              : "";

          const selectedGroupKey = localAccountTypes.value[props.index];
          const selectedGroup = chartOfAccounts.value.find(
            (group) => group.key === selectedGroupKey
          );

          if (selectedGroup) {
            parentAccounts.value = selectedGroup.accountHeadsDTO.flatMap(
              (head) => head.accounts || []
            );
          } else {
            parentAccounts.value = [];
          }
        }
      },
      { immediate: true, deep: true }
    );

    // watch(() => {
    //   if (
    //     props.accountGroupId &&
    //     props.transactionalAccounts &&
    //     Number.isInteger(props.index)
    //   ) {
    //     selectedAccountType.value = props.transactionalAccounts[
    //       props.index
    //     ].find((i) => i.name === props.accountGroupId);

    //     console.log(selectedAccountType.value, "selectedAccountType");
    //   }

    //   if (props.account) {
    //     newAccount.value.name = props.account ? props.account.name : "";
    //     newAccount.value.code = props.account ? props.account.code : "";
    //     newAccount.value.isSubAccount = props.account
    //       ? props.account.isSubAccount
    //       : false;
    //     newAccount.value.isContraAccount = props.account
    //       ? props.account.isContraAccount
    //       : false;
    //     newAccount.value.description = props.account
    //       ? props.account.description
    //       : "";
    //     selectedFund.value = funds.value.find(
    //       (i) => i.id === props.account.financialFundID
    //     );
    //     selectedCurrency.value = accountCurrencies.value.find(
    //       (i) => i.id === props.account.currencyID
    //     );
    //     selectedFundID.value = props.account.financialFundID || null;
    //     selectedCurrencyID.value = props.account.currencyID || null;

    //     setAcountHeadType.value =
    //       props.accountTypes && props.accountTypes[props.index]
    //         ? props.accountTypes[props.index]
    //         : "";

    //     const selectedGroupKey = localAccountTypes.value[props.index];
    //     const selectedGroup = chartOfAccounts.value.find(
    //       (group) => group.key === selectedGroupKey
    //     );

    //     if (selectedGroup) {
    //       parentAccounts.value = selectedGroup.accountHeadsDTO.flatMap(
    //         (head) => head.accounts || []
    //       );
    //     } else {
    //       parentAccounts.value = [];
    //     }
    //   }
    // });

    const setFundValue = (item) => {
      selectedFund.value = item;
    };

    const setCurrencyValue = (item) => {
      selectedCurrency.value = item;
    };

    return {
      chartOfAccounts,
      localTransactionalAccounts,
      localAccountTypes,
      filteredAccounts,
      setSelectedParentAccount,
      selectedParentAccountID,
      selectedParentAccount,
      parentAccounts,
      toggleAdvanced,
      isSubAccount,
      isContraAccount,
      isAdvancedOpen,
      selectedParentAccount,
      selectAccountType,
      setAcountHeadType,
      setSelectedFund,
      selectedFundID,
      selectedCurrencyID,
      setSelectedCurrency,
      selectedAccountType,
      filteredCurrencies,
      funds,
      newAccount,
      selectedCurrency,
      selectedFund,
      onSave,
      invalidAccountDetails,
      savingAccount,
      accountCurrencies,
      setFundValue,
      setCurrencyValue,
      primarycolor,
      loading,
    };
  },
};
</script>

<style scoped>
.p-dropdown-items {
  width: 100px !important;
}

.dropdown-menu {
  max-height: 400px;
  overflow: scroll;
}
</style>
